<div class="multiselect-container row justify-content-center no-gutters">
    <button type="button" class="multiselect-button col-12" (click)="toggleSelectDropdown($event)">
        <span>{{selectedDisplayText}} </span>
        <span class="nsdicon-angle-down"></span>
    </button>
    <div class="multiselect-list-container" [class.multiselect-list-container-upward]="config.upward"
        *ngIf="toggleDropdown" [style.maxHeight]="config.height">
        <div class="search-container" *ngIf="config.search">
            <input name="search" [(ngModel)]="searchText" />
            <label [ngClass]="{'active': searchText}">
                <span class="nsdicon-search"></span> Search</label>
        </div>
        <ul class="selected-items" id="selected-items">
            <li *ngFor="let selected of selectedItems;let i = index" (click)="deselectItem(selected,i)">
                <span class="nsdicon-close"> {{selected[config.displayKey] || selected}}</span>
            </li>
        </ul>
        <hr *ngIf="selectedItems.length > 0 && availableItems.length > 0" />
        <ul class="available-items" id="available-items">
            <ng-container *ngIf="availableItems.length || selectedItems.length; else emptyList">
                <li #availableOption
                    *ngFor="let item of availableItems| filterBy: searchText | limitTo : config.limitTo;let i = index"
                    [ngClass]="{'active': focusedItemIndex == i}" (click)="selectItem(item,i)">
                    {{item[config.displayKey] || item}}</li>
            </ng-container>

            <ng-template #emptyList>
                There are no {{ config.displayKey === 'PlaylistTitle' ? 'playlists' : 'connected monitors' }}
            </ng-template>
        </ul>
    </div>
</div>